import { type ComponentPropsWithoutRef, forwardRef } from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { cn } from '@/utils/tailwind.util';
export const SelectValue = forwardRef<HTMLSpanElement, ComponentPropsWithoutRef<'span'> & {
  placeholder?: string;
}>(({
  className,
  children,
  placeholder,
  ...props
}, ref) => {
  return <span className={cn('flex items-center min-w-0 truncate flex-1 text-start', !children && 'text-disabled', className)}>
      <span className={'inline-block w-full truncate'} ref={ref} {...props}>
        {children ?? placeholder}
      </span>
    </span>;
});
SelectValue.displayName = SelectPrimitive.Value.displayName;